module.exports = __webpack_public_path__ + "static/img/s155.bd813406.png";